"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableWrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../lib/utils");

var _templateObject;

var StyledTableWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: inherit !important;\n  thead {\n    th {\n      border-bottom: 1px solid\n        ", " !important;\n      color: inherit;\n      ", "\n\n      .MuiButton-root {\n        & > div {\n          align-items: center;\n          font-family: inherit;\n\n          & > div:first-child {\n            color: inherit;\n          }\n        }\n      }\n    }\n  }\n  tbody {\n    tr:nth-child(even) {\n      background-color: ", ";\n      &:hover {\n        background-color: ", " !important;\n      }\n    }\n    tr:nth-child(odd) {\n      background-color: ", ";\n      &:hover {\n        background-color: ", " !important;\n      }\n    }\n    td {\n      border-color: ", ";\n      color: inherit;\n      font-family: ", ";\n      font-weight: 300;\n      * {\n        font-family: ", ";\n      }\n    }\n  }\n  &.MuiPaper-root {\n    box-shadow: none;\n    border: none;\n    color: inherit;\n  }\n\n  .MuiTablePagination-root {\n    border-bottom: none;\n    color: inherit;\n\n    .Mui-disabled {\n      opacity: 0.3;\n    }\n  }\n  .MuiTableCell-root {\n    color: inherit;\n  }\n  .MuiSvgIcon-root {\n    path {\n      fill: ", ";\n    }\n  }\n  .MuiTableFooter-root {\n    border-top: 1px solid ", ";\n    height: 84px;\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('background', 'c01')(props);
}, function (props) {
  return (0, _utils.getTypography)('bodySemiBold')(props);
}, function (props) {
  return (0, _utils.getPalette)('background', 'c01')(props);
}, function (props) {
  return (0, _utils.getPalette)('background', 'c02')(props);
}, function (props) {
  return (0, _utils.getPalette)('background', 'c00')(props);
}, function (props) {
  return (0, _utils.getPalette)('background', 'c02')(props);
}, function (props) {
  return (0, _utils.getPalette)('background', 'c02')(props);
}, function (props) {
  return props.theme.typography.baseFontFamily;
}, function (props) {
  return props.theme.typography.baseFontFamily;
}, function (props) {
  return (0, _utils.getPalette)('text', 'c02')(props);
}, function (props) {
  return (0, _utils.getPalette)('background', 'c01')(props);
});

exports.StyledTableWrapper = StyledTableWrapper;